import {
  Configuration,
  LogLevel,
  OIDC_DEFAULT_SCOPES,
  PublicClientApplication,
} from '@azure/msal-browser';
import { ROUTES } from 'routing/routes';
import {
  AZURE_AD_B2C_CLIENT_ID,
  AZURE_AD_B2C_REDIRECTION_URI,
  AZURE_BACKEND_CLIENT_ID,
  AZURE_PASSWORD_RESET_POLICY,
  AZURE_SIGN_IN_SIGN_UP_POLICY,
  AZURE_TENANT_NAME,
  LEGAL_CORPORATIONS,
  PLATFORM_LANGUAGE,
  PLATFORM_LEGAL_CORPORATION_ID,
} from 'services/api/constants';
import { logger } from 'services/logs/logger';

const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: AZURE_AD_B2C_CLIENT_ID,
    authority: `https://${AZURE_TENANT_NAME}.b2clogin.com/${AZURE_TENANT_NAME}.onmicrosoft.com/${AZURE_SIGN_IN_SIGN_UP_POLICY}`,
    redirectUri: AZURE_AD_B2C_REDIRECTION_URI,
    postLogoutRedirectUri: AZURE_AD_B2C_REDIRECTION_URI + ROUTES.HOME,
    knownAuthorities: [`${AZURE_TENANT_NAME}.b2clogin.com`],
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            logger.logError('MSAL: ' + message);
            break;
          case LogLevel.Warning:
            logger.logWarn('MSAL: ' + message);
            break;
          case LogLevel.Info:
            logger.logInfo('MSAL: ' + message);
            break;
          case LogLevel.Verbose:
            // Only log verbose in development
            if (process.env.NODE_ENV === 'development') {
              logger.logInfo('MSAL: ' + message);
            }
            break;
        }
      },
      logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Info : LogLevel.Warning,
    },
  },
};

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

export const ACCESS_TOKEN_SCOPES = [
  `https://${AZURE_TENANT_NAME}.onmicrosoft.com/${AZURE_BACKEND_CLIENT_ID}/Access`,
];

const getLegalCorporationByRedirectionURI = () => {
  const isReeves = AZURE_AD_B2C_REDIRECTION_URI.match(/reevescc/gi);
  if (isReeves) return LEGAL_CORPORATIONS.Reeves;
  return '';
};
const legalCorporationID = getLegalCorporationByRedirectionURI();
export const PLATFORM_REVISED_LEGAL_CORPORATION_ID = legalCorporationID
  ? legalCorporationID
  : PLATFORM_LEGAL_CORPORATION_ID;
export const MSAL_REDIRECT_PARAMETERS = {
  scopes: OIDC_DEFAULT_SCOPES,
  extraQueryParameters: {
    sj: PLATFORM_REVISED_LEGAL_CORPORATION_ID,
    ui_locales: PLATFORM_LANGUAGE,
    cid: AZURE_AD_B2C_CLIENT_ID,
    tenant: AZURE_TENANT_NAME,
  },
};

// Authority for the B2C self-service password reset policy. The host is already
// covered by knownAuthorities, so only the policy path differs from sign-in.
export const PASSWORD_RESET_AUTHORITY = `https://${AZURE_TENANT_NAME}.b2clogin.com/${AZURE_TENANT_NAME}.onmicrosoft.com/${AZURE_PASSWORD_RESET_POLICY}`;

export const PASSWORD_RESET_REDIRECT_PARAMETERS = {
  authority: PASSWORD_RESET_AUTHORITY,
  scopes: OIDC_DEFAULT_SCOPES,
  extraQueryParameters: {
    ...MSAL_REDIRECT_PARAMETERS.extraQueryParameters,
  },
};
